module.exports = __webpack_public_path__ + "static/media/map.92fa6ead.png";